import React, { Fragment, useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";


import AdminKilometerService from '../../api/services/AdminKilometerService';
import swal from "sweetalert";
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const KilometerUpdate = () => {
    const [file, setFile] = useState()
    const [Error, setError] = useState('');
    const [isLoading, setisloading] = useState(true);
    const [Kilometer, SetKilometer] = useState([]);
    const params = useParams();
    const navigate = useNavigate()
    var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL;
    const GetKilometer = async (id) => {
        try {
            let responseData = await AdminKilometerService.show(id).json()
            SetKilometer(responseData.data);

            setisloading(false);

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            GetKilometer(params.id);
        }
        else {
            navigate('/');
        }

    }, [])
    const onFileChange = (e) => {
        const fileReader = new FileReader()
        fileReader.readAsDataURL(e.target.files[0])
        fileReader.onload = () => {
            var icon = fileReader.result
            setFile(icon)
        }
    }
    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            var userData = {
                title: event.target.title.value,
                "de_title": event.target.de_title.value,
                price: event.target.price.value,
                description: event.target.description.value,
                "de_description": event.target.de_description.value,
                icon: file ? file.split(',')[1] : "",
            }
            const data = await AdminKilometerService.update(params.id, userData).json();

            if (data.status === true) {

                swal("Kilometer Update Succesfully").then((willDelete) => {
                    if (willDelete) {
                        navigate('/admin/kilometer')
                    }
                })

            }


        }
        catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    return (
        <Fragment>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Kilometer</h4>
                            </div>
                            <div className="card-body">
                                <div className="form-validation">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-xl-12 mb-3">
                                                <label htmlFor="exampleFormControlInput1" className="form-label">English Title<span className="text-danger">*</span></label>
                                                <input type="text" name="title" defaultValue={Kilometer.title} className="form-control" id="exampleFormControlInput1" placeholder="" />
                                            </div>
                                            <div className="col-xl-12 mb-3">
                                                <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" defaultValue={Kilometer.de_title} />
                                            </div>
                                            <div className="col-xl-126 mb-3">
                                                <label htmlFor="exampleFormControlInput2" className="form-label"> Price <span className="text-danger">*</span></label>
                                                <input type="number" name='price' defaultValue={Kilometer.price} className="form-control" id="exampleFormControlInput2" placeholder="" />
                                            </div>

                                            <div className="col-xl-12 mb-3">
                                                <label className="form-label">English Description<span className="text-danger">*</span></label>
                                                <textarea rows="2" name='description' defaultValue={Kilometer.description} className="form-control"></textarea>
                                            </div>
                                            <div className="col-xl-12 mb-3">
                                                <label className="form-label" htmlFor="val-suggestions">German Description <span className="text-danger">*</span></label>
                                                <textarea rows="2" id="val-suggestions" className="form-control" name='de_description' defaultValue={Kilometer.de_description}></textarea>
                                            </div>
                                            <div className="col-xl-12 mb-3">
                                                <label htmlFor="val-number" className="form-label">Icon <span className="text-danger">*</span></label>

                                                {Kilometer.icon ? <img className="img-drop-area" height={100} width={100} name="image" src={file ? file : imageUrl + "Kilometer/" + Kilometer.icon} alt='' /> : null}
                                                <input type="file" className="form-control" name='image' id="val-number" onChange={onFileChange} accept="image/png, image/jpeg, image/svg+xml" />
                                            </div>
                                            <p className='text-danger fs-12'>{Error}</p>

                                        </div>
                                        <div>
                                            <button type="submit" className="btn btn-primary me-1">Submit</button>
                                            
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
        </Fragment>
    );
};

export default KilometerUpdate;
